
<div id="Sidebar">
    <div class="user-section">
        <a routerLink="/en/mrkg-mrkr/profile"><img class="profile-img" src="assets/userA.png" alt="assets/userA.png"></a>
    </div>
    <div class="menu">

    </div>
</div>
